import React from 'react';

import { IconProps } from './types';

/**
 * The 20px palette on the owner's Change theme circle.
 *
 * The path is the `my-personal` export's own (`Icon9`), with the hardcoded
 * black fill swapped for `currentColor` so the circle decides the colour, as it
 * does for Edit and Delete beside it.
 */
export const PaletteIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10 1.875C8.20964 1.875 6.33789 2.5 4.90234 3.84603C3.4668 5.19206 2.5 7.25911 2.5 10C2.5 11.8978 3.24381 13.8883 4.50358 15.4411C5.76497 16.9954 7.58138 18.125 9.70052 18.125C10.9912 18.125 11.9629 17.5911 12.5716 16.8766C13.182 16.1637 13.4619 15.3092 13.6051 14.6029C13.724 14.0202 14.1276 13.5384 14.694 13.2731C15.9049 12.7035 17.5 11.359 17.5 8.84603C17.5 5.05208 14.4076 1.875 10 1.875ZM10 3.125C13.8232 3.125 16.25 5.71615 16.25 8.84603C16.25 10.8577 15.1172 11.6927 14.1618 12.1403C13.2699 12.5602 12.5846 13.3594 12.3812 14.3538C12.264 14.9333 12.028 15.5908 11.6211 16.0661C11.2142 16.5413 10.6706 16.875 9.70052 16.875C8.02409 16.875 6.55436 15.9847 5.47526 14.6549C4.39616 13.3236 3.75 11.5641 3.75 10C3.75 7.5472 4.57682 5.86426 5.75684 4.75749C6.93685 3.65234 8.5026 3.125 10 3.125ZM10 4.375C9.3099 4.375 8.75 4.9349 8.75 5.625C8.75 6.3151 9.3099 6.875 10 6.875C10.6901 6.875 11.25 6.3151 11.25 5.625C11.25 4.9349 10.6901 4.375 10 4.375ZM6.875 6.25C6.1849 6.25 5.625 6.8099 5.625 7.5C5.625 8.1901 6.1849 8.75 6.875 8.75C7.5651 8.75 8.125 8.1901 8.125 7.5C8.125 6.8099 7.5651 6.25 6.875 6.25ZM13.125 6.25C12.4349 6.25 11.875 6.8099 11.875 7.5C11.875 8.1901 12.4349 8.75 13.125 8.75C13.8151 8.75 14.375 8.1901 14.375 7.5C14.375 6.8099 13.8151 6.25 13.125 6.25ZM6.875 10C6.1849 10 5.625 10.5599 5.625 11.25C5.625 11.9401 6.1849 12.5 6.875 12.5C7.5651 12.5 8.125 11.9401 8.125 11.25C8.125 10.5599 7.5651 10 6.875 10ZM9.375 12.5C8.6849 12.5 8.125 13.0599 8.125 13.75C8.125 14.4401 8.6849 15 9.375 15C10.0651 15 10.625 14.4401 10.625 13.75C10.625 13.0599 10.0651 12.5 9.375 12.5Z"
          fill={color}
        />
      </svg>
    );
  },
);
